module.exports = __webpack_public_path__ + "img/phone.dea31eb8.png";